import { connect } from 'react-redux';
import EngineMetricsDeltasComponent
  from './../Components/EngineMetricsDeltasComponent';
import {
  engineMetricsPageReducer,
  getCaseMetricsScanMetrics
} from './../reducers';
import { modal as modalActions } from './../actions';

export const mapStateToProps = (state) => {
  const selected = engineMetricsPageReducer.getEngineMetricsSelectedJobs(state);
  const jobs = getCaseMetricsScanMetrics(state);

  const primary = selected[0] ? jobs[selected[0].index] : undefined;
  const secondary = selected[1] ? jobs[selected[1].index] : undefined;

  return {
    // if selection without index then it is a url given selection, don't display
    primaryName: selected[0] ?
      selected[0].index >= 0 ? selected[0].value : undefined :
      undefined,
    secondaryName: selected[1] ? selected[1].value : undefined,
    ccfHitDelta: primary && secondary ?
      primary.ccf.hitCount - secondary.ccf.hitCount :
      0,
    ncfHitDelta: primary && secondary ?
      primary.ncf.hitCount - secondary.ncf.hitCount :
      0,
    sourceDelta: primary && secondary ?
      primary.ncf.sourceCount - secondary.ncf.sourceCount :
      0,
    sourceAttributeDelta: primary && secondary ?
      primary.ncf.sourceAttributeCount - secondary.ncf.sourceAttributeCount :
      0
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onLinkClick: (isCcf) => dispatch(
      modalActions.showArtifactHitCountModal(true, undefined, isCcf)
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EngineMetricsDeltasComponent);


// WEBPACK FOOTER //
// src/Containers/EngineMetricsDeltasContainer.jsx